import { StaticImage } from 'gatsby-plugin-image';
import { FormattedMessage, Link, useIntl } from 'gatsby-plugin-react-intl';
import * as React from 'react';
import { ROUTES } from '../../../../const/routes';
import { Routes } from '../../../../enum/Routes';
import { useSiteMetadata } from '../../../../hooks/useSiteMetadata';
import * as styles from './eu-program-banner.module.scss';

export const EuProgramBanner = () => {
  const intl = useIntl();
  const { siteMainLang } = useSiteMetadata();

  if (intl.locale !== siteMainLang) {
    return null;
  }

  return (
    <section className={`container ${styles.wrapper}`}>
      <div className={styles.banner}>
        <div className={styles.inner}>
          <StaticImage
            className={styles.logoEu}
            src="../../../../images/program-banner-2026/EU-Financed.png"
            placeholder="tracedSVG"
            loading="eager"
            width={280}
            quality={95}
            objectFit="contain"
            formats={['auto', 'webp', 'avif']}
            alt={intl.formatMessage({
              id: 'home.eu_program_banner.eu_logo_alt',
            })}
          />
          <div className={styles.content}>
            <p className={styles.text}>
              <FormattedMessage id="home.eu_program_banner.text" />
            </p>
            <Link
              to={`${ROUTES[Routes.ABOUT_US]()}#eu-program-3`}
              className={styles.details}
            >
              <FormattedMessage id="general.details_link" />
            </Link>
          </div>
          <StaticImage
            className={styles.logoProgram}
            src="../../../../images/program-banner-2026/Banner-Plakat-2026.png"
            placeholder="tracedSVG"
            loading="eager"
            width={160}
            quality={95}
            objectFit="contain"
            formats={['auto', 'webp', 'avif']}
            alt={intl.formatMessage({
              id: 'home.eu_program_banner.program_logo_alt',
            })}
          />
        </div>
      </div>
    </section>
  );
};
